import { useHierarchyArea } from '@plarium/hierarchy-react';
import React, { useMemo, useCallback } from 'react';

import { Button, Tooltip, Picker } from '@gogame/components';

import {
  CPE_ID,
  TYPE,
  TYPE_ID,
} from 'scenes/Campaigns/components/CostModel/constants';

export const CostModelPicker = ({
  onChange,
  disabled,
  source,
  isOptionDisabled,
  models,
  platformName,
}) => {
  const { data, loading } = useHierarchyArea({
    name: 'costModels',
    source: source,
    active: true,
  });
  const selectedModelIds = useMemo(() => {
    return models.map((model) => model[TYPE][TYPE_ID]);
  }, [models]);

  const unselectedOptions = useMemo(() => {
    if (data?.length) {
      const res = data.filter(
        (model) => model.id === CPE_ID || !selectedModelIds.includes(model.id)
      );
      return res;
    }
    return [];
  }, [data, selectedModelIds]);

  const handleChange = useCallback(
    ([opt]) => {
      onChange(opt);
    },
    [onChange]
  );

  const picker = (
    <Picker
      button={
        <Button add data-cy={'Button'} data-cy-label={'Cost Model'}>
          {platformName ? `${platformName} ` : ''}Cost Model
        </Button>
      }
      isOptionDisabled={isOptionDisabled}
      onChange={handleChange}
      options={unselectedOptions}
      disabled={disabled}
      loading={loading}
    />
  );

  return disabled ? (
    <Tooltip
      title={
        'The selected cost model cannot be combined with other cost models.'
      }
      wrapper
    >
      {picker}
    </Tooltip>
  ) : (
    picker
  );
};
